/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AddTeamMemberRequestBody = {
  userId: string;
};

export type AddTeamMemberRequest = {
  orgId: string;
  teamId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody?: AddTeamMemberRequestBody | undefined;
};

export type Member = {
  id: string;
  teamId: string;
  userId: string;
  createdAt: string;
};

/**
 * Member added
 */
export type AddTeamMemberResponseBody = {
  member: Member;
};

/** @internal */
export const AddTeamMemberRequestBody$inboundSchema: z.ZodType<
  AddTeamMemberRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  userId: z.string(),
});
/** @internal */
export type AddTeamMemberRequestBody$Outbound = {
  userId: string;
};

/** @internal */
export const AddTeamMemberRequestBody$outboundSchema: z.ZodType<
  AddTeamMemberRequestBody$Outbound,
  z.ZodTypeDef,
  AddTeamMemberRequestBody
> = z.object({
  userId: z.string(),
});

export function addTeamMemberRequestBodyToJSON(
  addTeamMemberRequestBody: AddTeamMemberRequestBody,
): string {
  return JSON.stringify(
    AddTeamMemberRequestBody$outboundSchema.parse(addTeamMemberRequestBody),
  );
}
export function addTeamMemberRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<AddTeamMemberRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AddTeamMemberRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AddTeamMemberRequestBody' from JSON`,
  );
}

/** @internal */
export const AddTeamMemberRequest$inboundSchema: z.ZodType<
  AddTeamMemberRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => AddTeamMemberRequestBody$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type AddTeamMemberRequest$Outbound = {
  orgId: string;
  teamId: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody?: AddTeamMemberRequestBody$Outbound | undefined;
};

/** @internal */
export const AddTeamMemberRequest$outboundSchema: z.ZodType<
  AddTeamMemberRequest$Outbound,
  z.ZodTypeDef,
  AddTeamMemberRequest
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => AddTeamMemberRequestBody$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function addTeamMemberRequestToJSON(
  addTeamMemberRequest: AddTeamMemberRequest,
): string {
  return JSON.stringify(
    AddTeamMemberRequest$outboundSchema.parse(addTeamMemberRequest),
  );
}
export function addTeamMemberRequestFromJSON(
  jsonString: string,
): SafeParseResult<AddTeamMemberRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AddTeamMemberRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AddTeamMemberRequest' from JSON`,
  );
}

/** @internal */
export const Member$inboundSchema: z.ZodType<Member, z.ZodTypeDef, unknown> = z
  .object({
    id: z.string(),
    teamId: z.string(),
    userId: z.string(),
    createdAt: z.string(),
  });
/** @internal */
export type Member$Outbound = {
  id: string;
  teamId: string;
  userId: string;
  createdAt: string;
};

/** @internal */
export const Member$outboundSchema: z.ZodType<
  Member$Outbound,
  z.ZodTypeDef,
  Member
> = z.object({
  id: z.string(),
  teamId: z.string(),
  userId: z.string(),
  createdAt: z.string(),
});

export function memberToJSON(member: Member): string {
  return JSON.stringify(Member$outboundSchema.parse(member));
}
export function memberFromJSON(
  jsonString: string,
): SafeParseResult<Member, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Member$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Member' from JSON`,
  );
}

/** @internal */
export const AddTeamMemberResponseBody$inboundSchema: z.ZodType<
  AddTeamMemberResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  member: z.lazy(() => Member$inboundSchema),
});
/** @internal */
export type AddTeamMemberResponseBody$Outbound = {
  member: Member$Outbound;
};

/** @internal */
export const AddTeamMemberResponseBody$outboundSchema: z.ZodType<
  AddTeamMemberResponseBody$Outbound,
  z.ZodTypeDef,
  AddTeamMemberResponseBody
> = z.object({
  member: z.lazy(() => Member$outboundSchema),
});

export function addTeamMemberResponseBodyToJSON(
  addTeamMemberResponseBody: AddTeamMemberResponseBody,
): string {
  return JSON.stringify(
    AddTeamMemberResponseBody$outboundSchema.parse(addTeamMemberResponseBody),
  );
}
export function addTeamMemberResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<AddTeamMemberResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AddTeamMemberResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AddTeamMemberResponseBody' from JSON`,
  );
}
